(function () {
  'use strict';

  var form = document.getElementById('ProductForm');
  if (!form) return;

  var variantsEl = document.getElementById('ProductVariants');
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var idInput = document.getElementById('ProductVariantId');
  var priceEl = document.getElementById('ProductPrice');
  var addBtn = document.getElementById('AddToCart');
  var gallery = document.querySelector('product-gallery');
  var optionGroups = Array.from(form.querySelectorAll('.option-selector'));

  function formatMoney(cents) {
    var format = window.themeMoneyFormat || '₹{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withCommas = parts.join('.');
    var withoutDecimals = parts[0];
    return format
      .replace('{{amount}}', withCommas)
      .replace('{{amount_no_decimals}}', withoutDecimals);
  }

  function currentSelection() {
    return optionGroups.map(function (group) {
      var selected = group.querySelector('.swatch.is-selected');
      return selected ? selected.dataset.value : null;
    });
  }

  function findVariant(selection) {
    return variants.find(function (variant) {
      return selection.every(function (value, i) {
        return value === null || variant.options[i] === value;
      });
    });
  }

  function goToVariantMedia(variant) {
    if (!gallery || !variant.featured_image) return;
    var slide = gallery.querySelector('[data-media-id="' + variant.featured_image.id + '"]');
    if (slide) gallery.goTo(parseInt(slide.dataset.index, 10));
  }

  function updateForVariant(variant) {
    if (!variant) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      return;
    }
    idInput.value = variant.id;
    if (priceEl) {
      var html = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = '<s>' + formatMoney(variant.compare_at_price) + '</s>' + html;
      }
      priceEl.innerHTML = html;
    }
    addBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    goToVariantMedia(variant);
  }

  form.addEventListener('click', function (e) {
    var swatch = e.target.closest('.swatch');
    if (!swatch) return;
    var group = swatch.closest('.option-selector');
    group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('is-selected'); });
    swatch.classList.add('is-selected');

    var variant = findVariant(currentSelection());
    if (variant) updateForVariant(variant);
  });

  // Sticky mobile add-to-cart bar: shown once the real button scrolls out of view.
  // CSS keeps this hidden entirely above the mobile breakpoint regardless of state.
  var stickyBar = document.getElementById('StickyAddToCart');
  if (stickyBar && addBtn && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.hidden = entry.isIntersecting;
      });
    }, { threshold: 0 });
    observer.observe(addBtn);
  }
})();
